import { Component, inject, Input } from '@angular/core';
import { GrowTotalNetIncome } from '@inyova/grow';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-inyova-grow-total-income-modal',
  templateUrl: './inyova-grow-total-income-modal.component.html',
  styleUrls: ['./inyova-grow-total-income-modal.component.scss'],
  standalone: false
})
export class InyovaGrowTotalIncomeModalComponent {
  private modalController = inject(ModalController);

  @Input() income: GrowTotalNetIncome;
  @Input() accountCurrency: string;

  info = {
    netIncome: false,
    perProjectBreakdown: false
  };

  onShowInfo(block: 'netIncome' | 'perProjectBreakdown') {
    this.info[block] = !this.info[block];
  }

  onViewTransactions(event: MouseEvent) {
    event.preventDefault();
    void this.modalController.dismiss({ viewTransactions: true });
  }

  onDismiss() {
    void this.modalController.dismiss();
  }
}
